import { render } from "./AccountsWidget.vue?vue&type=template&id=5bff5991&scoped=true"
import script from "./AccountsWidget.vue?vue&type=script&lang=js"
export * from "./AccountsWidget.vue?vue&type=script&lang=js"

import "./AccountsWidget.vue?vue&type=style&index=0&id=5bff5991&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bff5991"]])

export default __exports__